import { render, staticRenderFns } from "./Vedio.vue?vue&type=template&id=b91d5b2a&scoped=true&"
import script from "./Vedio.vue?vue&type=script&lang=js&"
export * from "./Vedio.vue?vue&type=script&lang=js&"
import style0 from "./Vedio.vue?vue&type=style&index=0&id=b91d5b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91d5b2a",
  null
  
)

export default component.exports